"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));

var _filter2 = _interopRequireDefault(require("lodash/filter"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTransitionGroup = require("react-transition-group");

var _WorkflowConsumer = _interopRequireDefault(require("./WorkflowConsumer"));

var _excluded = ["children"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint react/no-unused-state: 0 */

/* eslint react/sort-comp: 0 */
var WorkflowStepListImpl = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(WorkflowStepListImpl, _React$Component);

  var _super = _createSuper(WorkflowStepListImpl);

  function WorkflowStepListImpl() {
    var _this;

    (0, _classCallCheck2.default)(this, WorkflowStepListImpl);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getStepIds", function () {
      var stepIds = _react.default.Children.map(_this.props.children, function (child) {
        if ( /*#__PURE__*/_react.default.isValidElement(child)) {
          var _child$props = child.props,
              stepId = _child$props.stepId,
              isNavigable = _child$props.isNavigable; // if (child.type.prototype instanceof WorkflowStep) {

          if (isNavigable && stepId) {
            return stepId;
          }
        }

        return undefined; // undocumented behavior: filtered from React.Children.map result
      });

      return (0, _filter2.default)(stepIds, function (sid) {
        return !!sid;
      }); // let us not rely on that undocumented behavior
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getNextStepId", function (stepId) {
      var stepIds = _this.getStepIds();

      var stepIndex = (0, _findIndex2.default)(stepIds, function (sid) {
        return sid === stepId;
      });

      if (stepIndex > -1) {
        var resultIndex = stepIndex + 1;

        if (resultIndex < stepIds.length) {
          return stepIds[resultIndex];
        }
      }

      return undefined;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPreviousStepId", function (stepId) {
      var stepIds = _this.getStepIds();

      var stepIndex = (0, _findIndex2.default)(stepIds, function (sid) {
        return sid === stepId;
      });

      if (stepIndex > 0) {
        var resultIndex = stepIndex - 1;

        if (resultIndex < stepIds.length) {
          return stepIds[resultIndex];
        }
      }

      return undefined;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getArrayOfStepProps", function () {
      var arrayOfStepProps = _react.default.Children.map(_this.props.children, function (child) {
        if ( /*#__PURE__*/_react.default.isValidElement(child)) {
          if (child.props.stepId && child.props.isNavigable) {
            var _child$props2 = child.props,
                children = _child$props2.children,
                propsMinusChildren = (0, _objectWithoutProperties2.default)(_child$props2, _excluded); // eslint-disable-line no-unused-vars

            return propsMinusChildren;
          }
        }

        return undefined; // undocumented behavior: filtered from React.Children.map result
      }); // let us not rely on that undocumented behavior


      return (0, _filter2.default)(arrayOfStepProps, function (stepProps) {
        return !!stepProps;
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "findActiveStep", function (_ref) {
      var currentStepId = _ref.currentStepId;
      return _react.default.Children.toArray(_this.props.children).find(function (child) {
        return (0, _get2.default)(child, 'props.stepId') === currentStepId;
      }) || null;
    });
    return _this;
  }

  (0, _createClass2.default)(WorkflowStepListImpl, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/(0, _jsx2.default)(_react.default.Fragment, {}, void 0, /*#__PURE__*/(0, _jsx2.default)(_WorkflowConsumer.default, {}, void 0, function (_ref2) {
        var currentStepId = _ref2.currentStepId,
            goToStepCallCount = _ref2.goToStepCallCount,
            transitionName = _ref2.transitionName,
            transitionTimeout = _ref2.transitionTimeout;

        var activeStep = _this2.findActiveStep({
          currentStepId: currentStepId
        });

        var className = "".concat((0, _get2.default)(activeStep, 'props.fixedHeight') ? 'fixed-height' : '', " ").concat((0, _get2.default)(activeStep, 'props.minHeight') ? 'min-height' : '');
        var onStepEnter = (0, _get2.default)(activeStep, 'props.onStepEnter');
        var onStepEntering = (0, _get2.default)(activeStep, 'props.onStepEntering');
        var onStepEntered = (0, _get2.default)(activeStep, 'props.onStepEntered');
        var onStepExit = (0, _get2.default)(activeStep, 'props.onStepExit');
        var onStepExiting = (0, _get2.default)(activeStep, 'props.onStepExiting');
        var onStepExited = (0, _get2.default)(activeStep, 'props.onStepExited');
        return /*#__PURE__*/(0, _jsx2.default)(_reactTransitionGroup.TransitionGroup, {
          id: _this2.props.containerId,
          component: "div",
          className: className
        }, void 0, !!activeStep ? /*#__PURE__*/(0, _jsx2.default)(_reactTransitionGroup.CSSTransition, {
          timeout: transitionTimeout || 100,
          classNames: transitionName || 'workflow-step',
          unmountOnExit: true,
          appear: true,
          onEnter: !onStepEnter ? undefined : function (node, isAppearing) {
            onStepEnter(activeStep.props);
          },
          onEntering: !onStepEntering ? undefined : function (node, isAppearing) {
            onStepEntering(activeStep.props);
          },
          onEntered: !onStepEntered ? undefined : function (node, isAppearing) {
            onStepEntered(activeStep.props);
          },
          onExit: !onStepExit ? undefined : function (node) {
            onStepExit(activeStep.props);
          },
          onExiting: !onStepExiting ? undefined : function (node) {
            onStepExiting(activeStep.props);
          },
          onExited: !onStepExited ? undefined : function (node) {
            onStepExited(activeStep.props);
          }
        }, "".concat(activeStep.props.stepId, "_").concat(goToStepCallCount), activeStep) : null);
      }));
    }
  }]);
  return WorkflowStepListImpl;
}(_react.default.Component);

WorkflowStepListImpl.displayName = 'WorkflowV2.StepListImpl';
var _default = WorkflowStepListImpl;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/workflow/impl/WorkflowStepListImpl.js
// module id = 4509
// module chunks = 25